import React, { useEffect, useState } from "react";

import { Button, Menu } from "antd";
import { Col, Row } from "react-bootstrap";
import "react-circular-progressbar/dist/styles.css";
import { FaUserFriends } from "react-icons/fa";
import { IoImageOutline } from "react-icons/io5";
import { connect } from "react-redux";
import { apiClient } from "../../components/apiClient";
import CustomDropDown from "../../components/CustomDropDown";
import DisplayScreen from "../../components/Dashboard/DisplayScreen";
import CustomDataTable from "../../components/DataTable";
import "./dashboard.css";

const Dashboard = ({ accessToken, display, userProfile, sellerId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [layoutCount, setLayoutCount] = useState(null);
  const [Imagesandvideoscount, setImagesandvideoscount] = useState(null);
  const [Displaycount, setDisplaycount] = useState(null);
  // const [MostUsedLayouts, setMostUsedLayouts] = useState(null);
  const [filterData, setFilterData] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    const getDashboardData = () => {
      setIsLoading(true);
      apiClient(accessToken)
        .get(`dashboard/mediasize/${sellerId}`)
        .then((res) => {
          setIsLoading(false);
          setDashboardData(res.data);
        })
        .catch((err) => {
          console.error("Error fetching dashboard data:", err);
          setIsLoading(false);
        });
    };

    const getDisplaycount = () => {
      setIsLoading(true);
      apiClient(accessToken)
        .get(`dashboard/devicecount/${sellerId}`)
        .then((res) => {
          setIsLoading(false);
          setDisplaycount(res.data);
        })
        .catch((err) => {
          console.error("Error fetching devicecount data:", err);
          setIsLoading(false);
        });
    };

    const getLayoutCount = () => {
      setIsLoading(true);
      apiClient(accessToken)
        .get(`dashboard/layoutcount/${sellerId}`)
        .then((res) => {
          setIsLoading(false);
          setLayoutCount(res.data);
        })
        .catch((err) => {
          console.error("Error fetching layout count data:", err);
          setIsLoading(false);
        });
    };

    const getImagesvideoscount = () => {
      setIsLoading(true);
      apiClient(accessToken)
        .get(`dashboard/library/${sellerId}`)
        .then((res) => {
          setIsLoading(false);
          setImagesandvideoscount(res.data);
        })
        .catch((err) => {
          console.error("Error fetching additional data:", err);
          setIsLoading(false);
        });
    };

    const getLocationList = () => {
      setIsLoading(true);
      apiClient(accessToken)
        .get(`store/storelist/${sellerId}`)
        .then((res) => {
          setIsLoading(false);

          // Extract the data
          const locationData = res.data.data;

          // Sort the data alphabetically (assuming each item has a "name" property to sort by)
          const sortedData = locationData.sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });

          setFilterData(sortedData);
        })
        .catch((err) => {
          console.error(err);
          setIsLoading(false);
        });
    };

    getDashboardData();
    getLayoutCount();
    getImagesvideoscount();
    getDisplaycount();
    getLocationList();
  }, [accessToken, sellerId]);

  const handleLocationFilter = (location) => {
    const selectedLocationString = selectedLocation
      ? selectedLocation.toString()
      : null;
    const locationString = location.toString();
    setSelectedLocation(
      locationString === selectedLocationString ? null : locationString
    );
  };

  const handleStatusFilter = (status) => {
    const selectedStatusString = selectedStatus
      ? selectedStatus.toString()
      : null;
    const statusString = status.toString();

    setSelectedStatus(
      statusString === selectedStatusString ? null : statusString
    );
  };

  const clearFilters = () => {
    setSelectedLocation(null);
    setSelectedStatus(null);
  };

  const filteredData = filterData.filter((item) => {
    return (
      (!selectedLocation || item.name === selectedLocation) &&
      (!selectedStatus || item.status.toString() === selectedStatus)
    );
  });

  const items = filterData.map((eachLocation, index) => {
    return {
      key: `${index}`,
      label: (
        <div
          key={index}
          onClick={() => handleLocationFilter(eachLocation.name)}
          className={`tw-w-52 tw-truncate tw-px-4 tw-py-2 tw-rounded-md ${
            selectedLocation === eachLocation.name
              ? "tw-bg-[#1890ff] tw-text-white tw-font-bold"
              : "tw-bg-transparent tw-text-black"
          }`}
        >
          {eachLocation.name}
        </div>
      ),
    };
  });
  const StatusFilterMenu = (
    <Menu onClick={({ key }) => handleStatusFilter(key)}>
      <Menu.Item key="1">Active</Menu.Item>
      <Menu.Item key="2">Inactive</Menu.Item>
    </Menu>
  );

  const columns = [
    {
      name: "Name",
      selector: (param) => param.name,
      sortable: true,
    },
    {
      name: "Address",
      selector: (param) => param.address,
      sortable: true,
    },

    {
      name: "No.of Displays",
      selector: (param) => param.DisplayLocationCount,
      sortable: true,
    },
    {
      name: "Status",
      selector: (param) => param.status,
      format: (param) => {
        if (param.status === 1 || param.status === "1") {
          return <span className="statusTab activve">Active</span>;
        } else {
          return <span className="statusTab deactive">In Active</span>;
        }
      },
      sortable: true,
    },
  ];

  return (
    <div className="dashboard-bg-container contents">
      <div className="displays-bg-container">
        <Row className="py-2">
          <Col md={6}>
            <h6 className="tw-text-lg">Dashboard</h6>
          </Col>
        </Row>
        <div className="tw-flex tw-justify-between">
          <div className="tw-flex tw-gap-3 tw-items-center">
            <CustomDropDown
              text={selectedLocation || "Location"}
              items={items}
            />
            <CustomDropDown
              filterMenu={StatusFilterMenu}
              selectedStatus={selectedStatus}
              text={
                selectedStatus === "1"
                  ? "Active"
                  : selectedStatus === "2"
                  ? "In Active"
                  : "Status"
              }
            />

            {selectedLocation || selectedStatus ? (
              <Button className="clear-filter-btn" onClick={clearFilters}>
                X
              </Button>
            ) : null}
          </div>
          <Col align="" md={6} className="add-layout-search-container"></Col>
        </div>
        <ul className="!tw-pl-0 tw-flex tw-flex-wrap tw-gap-6 tw-w-full tw-mt-10 tw-justify-between">
          <li
            className="tw-shadow-xl tw-rounded-md tw-bg-[#fff] tw-p-3 tw-flex tw-justify-center tw-items-center"
            style={{ width: "220px" }}
          >
            <div className="tw-flex tw-justify-between tw-gap-4">
              <div className="tw-max-w-32">
                <h4 className="tw-font-sans tw-font-semibold tw-text-[#4c4c4c] tw-text-[18px]">
                  Total Images and videos
                </h4>
                {Imagesandvideoscount && (
                  <h4 className="tw-font-bold tw-font-sans tw-text-[30px]">
                    {Imagesandvideoscount.totalImagesvideos}
                  </h4>
                )}
              </div>
              <div className=" tw-bg-[#dfdeff] tw-w-12 tw-h-12  tw-flex tw-items-center tw-justify-center tw-rounded-md">
                <IoImageOutline
                  style={{ fontSize: "30px", color: "#8280FF" }}
                />
              </div>
            </div>
          </li>
          <li
            className=" tw-shadow-xl tw-rounded-md tw-bg-[#fff] tw-p-3 tw-flex tw-justify-center tw-items-center"
            style={{ width: "220px" }}
          >
            <div className="tw-flex tw-justify-between tw-gap-4">
              <div className=" tw-max-w-32">
                <h4 className="tw-font-sans tw-font-semibold tw-text-[#4c4c4c] tw-text-[18px]">
                  Total Devices
                </h4>
                {Displaycount && (
                  <h4 className="tw-font-bold tw-font-sans tw-text-[30px]">
                    {Displaycount.count}
                  </h4>
                )}
              </div>
              <div className=" tw-bg-[#dfdeff] tw-w-12 tw-h-12  tw-flex tw-items-center tw-justify-center tw-rounded-xl">
                <FaUserFriends style={{ fontSize: "30px", color: "#8280FF" }} />
              </div>
            </div>
          </li>
          <li
            className=" tw-shadow-xl tw-rounded-md tw-bg-[#fff] tw-p-3 tw-flex tw-justify-center tw-items-center"
            style={{ width: "220px" }}
          >
            <div className="tw-flex tw-justify-between tw-gap-4">
              <div className=" tw-max-w-32">
                <h4 className="tw-font-sans tw-font-semibold tw-text-[#4c4c4c] tw-text-[18px]">
                  Total Layouts
                </h4>
                {layoutCount && (
                  <h4 className="tw-font-bold tw-font-sans tw-text-[30px]">
                    {layoutCount.count}
                  </h4>
                )}
              </div>
              <div className=" tw-bg-[#dfdeff] tw-w-12 tw-h-12  tw-flex tw-items-center tw-justify-center tw-rounded-xl">
                <IoImageOutline
                  style={{ fontSize: "30px", color: "#8280FF" }}
                />
              </div>
            </div>
          </li>
          <li
            className=" tw-shadow-xl tw-rounded-md tw-bg-[#fff] tw-p-3 tw-flex tw-justify-center tw-items-center"
            style={{ width: "220px" }}
          >
            <div className="tw-flex tw-justify-between tw-gap-4">
              <div className=" tw-max-w-32">
                <h4 className="tw-font-sans tw-font-semibold tw-text-[#4c4c4c] tw-text-[18px]">
                  Total storage size used
                </h4>

                {dashboardData && (
                  <h4 className="tw-font-bold tw-font-sans tw-text-[30px]">
                    {parseFloat(dashboardData.totalMediaSize).toFixed(3)}MB
                  </h4>
                )}
              </div>
              <div className=" tw-bg-[#dfdeff] tw-w-12 tw-h-12  tw-flex tw-items-center tw-justify-center tw-rounded-xl">
                <IoImageOutline
                  style={{ fontSize: "30px", color: "#8280FF" }}
                />
              </div>
            </div>
          </li>
        </ul>

        {isLoading ? (
          <Row>
            <Col
              md={12}
              align="center"
              className="tw-flex tw-items-center tw-h-screen"
            >
              <div className="loader"></div>
            </Col>
          </Row>
        ) : (
          <div>
            <h6 className="tw-mt-8 tw-font-sans tw-text-lg">Location</h6>
            {filteredData.length > 0 ? (
              <CustomDataTable
                columns={columns}
                data={filteredData}
                tableKey="dashboardTable"
              />
            ) : (
              <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-text-black tw-bg-white tw-py-8 tw-rounded-xl">
                No Location data found
              </div>
            )}
          </div>
        )}

        <DisplayScreen sellerId={sellerId} accessToken={accessToken} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  accessToken: state.accessToken,
  userProfile: state.userProfile,
  sellerId: state.sellerIdReducer,
  ...state,
});

export default connect(mapStateToProps)(Dashboard);
